import API from '../API/ApiURL';
import { axiosNode } from '../config/axiosConfig';
import { alertErrorResponse } from '../utils/alertResponseHttpUtil';

const configApi = {
  headers: { Token: '', rol: '' },
};

const ROUTE = `${API.serverUrl}logs`;

export default {
  async crear(body) {
    try {
      const response = await axiosNode.post(ROUTE, body, configApi);
      return response.data;
    } catch (error) {
      alertErrorResponse(error.response.data);
    }
  },

  async buscarTodos() {
    try {
      const response = await axiosNode.get(ROUTE, configApi);
      return response.data;
    } catch (error) {
      alertErrorResponse(error.response.data);
    }
  },
};
